import { render, staticRenderFns } from "./waveDialog.vue?vue&type=template&id=234006aa&scoped=true"
import script from "./waveDialog.vue?vue&type=script&lang=js"
export * from "./waveDialog.vue?vue&type=script&lang=js"
import style0 from "./waveDialog.vue?vue&type=style&index=0&id=234006aa&prod&scoped=true&lang=css"
import style1 from "./waveDialog.vue?vue&type=style&index=1&id=234006aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234006aa",
  null
  
)

export default component.exports